import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {tagsList_template} from "../components/templates/tagsList_template";
import {vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";
import {tagTypesList_template} from "../components/templates/tagTypesList_template";

declare var ko: any;
declare var page: any;

export class tagTypes extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: tagTypesList_template;
    protected pagination: pagination_template;

    protected getModuleName(){

        return "tagTypes";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.elementsList = new tagTypesList_template("list", this.viewModel, this);

        //only show Add Job Profile button if CM or Admin
        let vnApp = this.getVnAppZone().app;
        let roles = vnApp.loggedUser.user.valnet_user.roles;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Tag Types List");


        if (this.isBrand()) {
            this.elementsList.setBrandId(this.getBrandId());
        } else {

            this.elementsList.setBrandId(undefined);
        }

        return [this.elementsList.build()];
    }

    public fillPage() : void{

        this.filterList();
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected tagsListReorder(){

        this.filterList();
    }

    protected filterDropdownOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected getMemoryViewModel(){
        let templateViewModel = this.elementsList.getTemplateViewModel();

        delete templateViewModel.tagTypes;

        return templateViewModel;
    }

    protected filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));


        let usrReq_url: string = this.buildListRequestUrl();

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });
            obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
        }
    }


    // update the module list using the objects list
    protected updateList(responseParsed: any){

        let mainUrl = '/categorization/tag-types/view/';
        if (this.isBrand()) {
            mainUrl = '/brand/' + this.getBrandId() + '/categorization/tag-types/view/';
        }
        // set Jobs list
        let tagTypesToSet = [];
        for (let item of responseParsed.data) {
            tagTypesToSet.push( {
                id: item.id,
                emakiView: mainUrl + item.id,
                name: item.name,
                slug : item.slug,
                productSchemaTemplate : item.productSchemaTemplate ? item.productSchemaTemplate.name : '',
                dataset : item.dataset ? item.dataset.name : '',
                type: item.type ? item.type.name : '',
                description: item.details ? item.details.description : '',
                isSelectable: item.details ? item.details.isSelectable : false,
                brandOwner: item.brandOwner? item.brandOwner : null,
            });
        }

        this.elementsList.setTagTypes(tagTypesToSet);

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

        // update the paginator
        this.viewModel.list.pagination.itemCount(responseParsed.totalCount);
    }

    protected viewTagType(id){

        this.saveViewModule(this.getMemoryViewModel());
        let url = this.buildViewRequestUrl(id);
        page(url);
    }

    protected createTagType(){

        this.saveViewModule(this.getMemoryViewModel());
        page('/categorization/tag-types/add/');
    }


    protected buildListRequestUrl(): string {

        let usrReq_url: string = '/api/tag/types/get';

        if (this.isBrand()) {

            let brandId = this.getBrandId();
            usrReq_url = '/api/brand/' + brandId + '/tag/types/get';
        }
        return usrReq_url;
    }


    protected buildViewRequestUrl(id: number): string {

        let url = '/categorization/tag-types/view/' + id;

        if (this.isBrand()) {

            let brandId = this.getBrandId();
            url = '/brand/' + brandId +'/categorization/tag-types/view/' + id;
        }
        return url;
    }

    public isBrand(): boolean {

        let number = Number(this.getBrandId());
        return Number.isInteger(number);
    }

    public getBrandId(): number {

        return Number(this.getVnAppZone().app.params.idBrand);
    }

    protected getDatasetSuggestion(keyword, limit = null, restrictOwnedTagTypes = false) {
    
            if (this.XHRHdl) {
                this.XHRHdl.cancelAndReset();
            }
    
            let subViewModel = {
                keyword: keyword,
                limit: limit,
                restrictOwnedTagTypes: restrictOwnedTagTypes,
            };
            let idBrand = this.getVnAppZone().getApp().params.idBrand;
            let usrReq_url: string = '';
            if (idBrand) {
                usrReq_url = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/tag/dataset/";
            }else{
                usrReq_url = "/api/search/tag/dataset/";
            }
            let usrReq_params: Array<Array<string>> = [];
            usrReq_params.push(["data", ko.toJSON(subViewModel)]);
            this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    
            this.XHRHdl.onReadyStateFunction = this.onGetDatasetSuggestionReturn;
            this.XHRHdl.execute();
    
        }
    
        protected onGetDatasetSuggestionReturn(req, obj) {
            return function () {
                obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                let datasets = responseParsed.data.templateTypes;
    
                obj.elementsList.setDatasetFilter(datasets);
                });
            };
        }
}



// WEBPACK FOOTER //
// ./js/modules/tagTypes.ts